/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { CaptureLabelSchema } from './CaptureLabelSchema';
import {
    CaptureLabelSchemaFromJSON,
    CaptureLabelSchemaFromJSONTyped,
    CaptureLabelSchemaToJSON,
    CaptureLabelSchemaToJSONTyped,
} from './CaptureLabelSchema';
import type { PhoneGps } from './PhoneGps';
import {
    PhoneGpsFromJSON,
    PhoneGpsFromJSONTyped,
    PhoneGpsToJSON,
    PhoneGpsToJSONTyped,
} from './PhoneGps';
import type { TriageResult } from './TriageResult';
import {
    TriageResultFromJSON,
    TriageResultFromJSONTyped,
    TriageResultToJSON,
    TriageResultToJSONTyped,
} from './TriageResult';
import type { CaptureAnnotation } from './CaptureAnnotation';
import {
    CaptureAnnotationFromJSON,
    CaptureAnnotationFromJSONTyped,
    CaptureAnnotationToJSON,
    CaptureAnnotationToJSONTyped,
} from './CaptureAnnotation';
import type { CaptureSource } from './CaptureSource';
import {
    CaptureSourceFromJSON,
    CaptureSourceFromJSONTyped,
    CaptureSourceToJSON,
    CaptureSourceToJSONTyped,
} from './CaptureSource';
import type { ManualCaptureOrigin } from './ManualCaptureOrigin';
import {
    ManualCaptureOriginFromJSON,
    ManualCaptureOriginFromJSONTyped,
    ManualCaptureOriginToJSON,
    ManualCaptureOriginToJSONTyped,
} from './ManualCaptureOrigin';
import type { SpeciesResultSchema } from './SpeciesResultSchema';
import {
    SpeciesResultSchemaFromJSON,
    SpeciesResultSchemaFromJSONTyped,
    SpeciesResultSchemaToJSON,
    SpeciesResultSchemaToJSONTyped,
} from './SpeciesResultSchema';
import type { TriggerSource } from './TriggerSource';
import {
    TriggerSourceFromJSON,
    TriggerSourceFromJSONTyped,
    TriggerSourceToJSON,
    TriggerSourceToJSONTyped,
} from './TriggerSource';

/**
 * 
 * @export
 * @interface CaptureSummary
 */
export interface CaptureSummary {
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    catchId: string | null;
    /**
     * 
     */
    runId: string | null;
    /**
     * 
     */
    deviceId: string | null;
    /**
     * 
     */
    hostname: string | null;
    /**
     * 
     */
    displayCode: string | null;
    /**
     * 
     */
    triggerSource: TriggerSource | null;
    /**
     * 
     */
    captureStartTimestamp: number | null;
    /**
     * 
     */
    captureEndTimestamp: number | null;
    /**
     * 
     */
    captureDurationSeconds: number | null;
    /**
     * 
     */
    lengthMillimeters: number | null;
    /**
     * 
     */
    weightGrams: number | null;
    /**
     * 
     */
    hasError: boolean;
    /**
     * 
     */
    thumbnailUrl: string | null;
    /**
     * 
     */
    triageResult: TriageResult;
    /**
     * 
     */
    annotation: CaptureAnnotation | null;
    /**
     * 
     */
    source: CaptureSource;
    /**
     * 
     */
    linkedCaptureId: string | null;
    /**
     * 
     */
    manualOrigin?: ManualCaptureOrigin | null;
    /**
     * 
     */
    phoneLoggedAt?: Date | null;
    /**
     * 
     */
    phoneGps?: PhoneGps | null;
    /**
     * 
     */
    speciesResult?: SpeciesResultSchema | null;
    /**
     * 
     */
    serverLengthMillimeters?: number | null;
    /**
     * 
     */
    labels?: Array<CaptureLabelSchema>;
}



/**
 * Check if a given object implements the CaptureSummary interface.
 */
export function instanceOfCaptureSummary(value: object): value is CaptureSummary {
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    if ((!('catchId' in (value as Record<string, any>)) && !('catch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['catchId'] === undefined && (value as Record<string, any>)['catch_id'] === undefined)) return false;
    if ((!('runId' in (value as Record<string, any>)) && !('run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['runId'] === undefined && (value as Record<string, any>)['run_id'] === undefined)) return false;
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    if ((!('displayCode' in (value as Record<string, any>)) && !('display_code' in (value as Record<string, any>))) || ((value as Record<string, any>)['displayCode'] === undefined && (value as Record<string, any>)['display_code'] === undefined)) return false;
    if ((!('triggerSource' in (value as Record<string, any>)) && !('trigger_source' in (value as Record<string, any>))) || ((value as Record<string, any>)['triggerSource'] === undefined && (value as Record<string, any>)['trigger_source'] === undefined)) return false;
    if ((!('captureStartTimestamp' in (value as Record<string, any>)) && !('capture_start_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureStartTimestamp'] === undefined && (value as Record<string, any>)['capture_start_timestamp'] === undefined)) return false;
    if ((!('captureEndTimestamp' in (value as Record<string, any>)) && !('capture_end_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureEndTimestamp'] === undefined && (value as Record<string, any>)['capture_end_timestamp'] === undefined)) return false;
    if ((!('captureDurationSeconds' in (value as Record<string, any>)) && !('capture_duration_seconds' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureDurationSeconds'] === undefined && (value as Record<string, any>)['capture_duration_seconds'] === undefined)) return false;
    if ((!('lengthMillimeters' in (value as Record<string, any>)) && !('length_millimeters' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMillimeters'] === undefined && (value as Record<string, any>)['length_millimeters'] === undefined)) return false;
    if ((!('weightGrams' in (value as Record<string, any>)) && !('weight_grams' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightGrams'] === undefined && (value as Record<string, any>)['weight_grams'] === undefined)) return false;
    if ((!('hasError' in (value as Record<string, any>)) && !('has_error' in (value as Record<string, any>))) || ((value as Record<string, any>)['hasError'] === undefined && (value as Record<string, any>)['has_error'] === undefined)) return false;
    if ((!('thumbnailUrl' in (value as Record<string, any>)) && !('thumbnail_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['thumbnailUrl'] === undefined && (value as Record<string, any>)['thumbnail_url'] === undefined)) return false;
    if ((!('triageResult' in (value as Record<string, any>)) && !('triage_result' in (value as Record<string, any>))) || ((value as Record<string, any>)['triageResult'] === undefined && (value as Record<string, any>)['triage_result'] === undefined)) return false;
    if (!('annotation' in value) || value['annotation'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if ((!('linkedCaptureId' in (value as Record<string, any>)) && !('linked_capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['linkedCaptureId'] === undefined && (value as Record<string, any>)['linked_capture_id'] === undefined)) return false;
    return true;
}

export function CaptureSummaryFromJSON(json: any): CaptureSummary {
    return CaptureSummaryFromJSONTyped(json, false);
}

export function CaptureSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'captureId': json['capture_id'],
        'catchId': json['catch_id'],
        'runId': json['run_id'],
        'deviceId': json['device_id'],
        'hostname': json['hostname'],
        'displayCode': json['display_code'],
        'triggerSource': TriggerSourceFromJSON(json['trigger_source']),
        'captureStartTimestamp': json['capture_start_timestamp'],
        'captureEndTimestamp': json['capture_end_timestamp'],
        'captureDurationSeconds': json['capture_duration_seconds'],
        'lengthMillimeters': json['length_millimeters'],
        'weightGrams': json['weight_grams'],
        'hasError': json['has_error'],
        'thumbnailUrl': json['thumbnail_url'],
        'triageResult': TriageResultFromJSON(json['triage_result']),
        'annotation': CaptureAnnotationFromJSON(json['annotation']),
        'source': CaptureSourceFromJSON(json['source']),
        'linkedCaptureId': json['linked_capture_id'],
        'manualOrigin': json['manual_origin'] === undefined ? undefined : json['manual_origin'] === null ? null : ManualCaptureOriginFromJSON(json['manual_origin']),
        'phoneLoggedAt': json['phone_logged_at'] === undefined ? undefined : json['phone_logged_at'] === null ? null : (parseDateTime(json['phone_logged_at'])),
        'phoneGps': json['phone_gps'] === undefined ? undefined : json['phone_gps'] === null ? null : PhoneGpsFromJSON(json['phone_gps']),
        'speciesResult': json['species_result'] === undefined ? undefined : json['species_result'] === null ? null : SpeciesResultSchemaFromJSON(json['species_result']),
        'serverLengthMillimeters': json['server_length_millimeters'] === undefined ? undefined : json['server_length_millimeters'] === null ? null : json['server_length_millimeters'],
        'labels': json['labels'] == null ? undefined : ((json['labels'] as Array<any>).map(CaptureLabelSchemaFromJSON)),
    };
}

export function CaptureSummaryToJSON(json: any): CaptureSummary {
    return CaptureSummaryToJSONTyped(json, false);
}

export function CaptureSummaryToJSONTyped(value?: CaptureSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_id': value['captureId'],
        'catch_id': value['catchId'],
        'run_id': value['runId'],
        'device_id': value['deviceId'],
        'hostname': value['hostname'],
        'display_code': value['displayCode'],
        'trigger_source': TriggerSourceToJSON(value['triggerSource']),
        'capture_start_timestamp': value['captureStartTimestamp'],
        'capture_end_timestamp': value['captureEndTimestamp'],
        'capture_duration_seconds': value['captureDurationSeconds'],
        'length_millimeters': value['lengthMillimeters'],
        'weight_grams': value['weightGrams'],
        'has_error': value['hasError'],
        'thumbnail_url': value['thumbnailUrl'],
        'triage_result': TriageResultToJSON(value['triageResult']),
        'annotation': CaptureAnnotationToJSON(value['annotation']),
        'source': CaptureSourceToJSON(value['source']),
        'linked_capture_id': value['linkedCaptureId'],
        'manual_origin': ManualCaptureOriginToJSON(value['manualOrigin']),
        'phone_logged_at': value['phoneLoggedAt'] == null ? value['phoneLoggedAt'] : serializeDateTime(value['phoneLoggedAt']),
        'phone_gps': PhoneGpsToJSON(value['phoneGps']),
        'species_result': SpeciesResultSchemaToJSON(value['speciesResult']),
        'server_length_millimeters': value['serverLengthMillimeters'],
        'labels': value['labels'] == null ? undefined : ((value['labels'] as Array<any>).map(CaptureLabelSchemaToJSON)),
    };
}

